import React from "react";

import { FeaturedContainer, Link, Col, Row } from "./index.style";
import { Container, Title } from "../index.style";
import PlaceHolder from "../../../images/featured.png";

const Featured = () => {
  return (
    <FeaturedContainer>
      <Container>
        <Row>
          <Col className="col">
            <img src={PlaceHolder} alt="Featured Employer" />
          </Col>
          <Col className="col featured">
            <Title> Featured employer </Title>
            <p>
              Stand apart on world's #1 job site. Maximize the exposure of your
              company brand and jobs to your ideal talent as a
              <Link href="/contact-us">Featured Employer.</Link>
            </p>

            <Link href="/contact-us" className="more">Learn more about Featured Employer</Link>
            <p className="source">Source: comScore. Totals visits. April 2020</p>
          </Col>
        </Row>
      </Container>
    </FeaturedContainer>
  );
};

export default Featured;
